module.exports = __webpack_public_path__ + "8b7df82467ec1c80d4b26afead5ae1a5.svg";